/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/NextAction/Content"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let questionAnswerValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'answer',
})
let questionRequiredValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'required',
})
let questionIsValidValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'isValid',
})
let questionSkipTextValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'skipText',
})
let aggregateData = fromHelpers.canSkip(questionAnswerValueData, questionRequiredValueData, questionIsValidValueData, questionSkipTextValueData)
let onPress = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 alignSelf="flex-end"
 marginTop={dtSpaceL}
 onClick={onClick}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="question.answer"
 data="question.required"
 data="question.isValid"
 data="question.skipText"
 aggregate="helpers.js canSkip"
 text={aggregateData}
/>
)}
</TysiaButton>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="enter"
 onPress={onPress}
/>
{children}
</React.Fragment>)
}